// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__21agT","approved":"Status_approved__28JcJ","rejected":"Status_rejected__2Htl5","expired":"Status_expired__3S0FX","label":"Status_label__2G5Vg"};